export const SET_OP_CODE_MISMATCH_RESULTS = 'SetOpCodeMismatchResults';
export const SET_OP_CODE_MISMATCH_ORDER = 'SetOpCodeMismatchOrder';
export const SET_OPERATION_MISMATCH_RESULTS = 'SetOperationMismatchResults';
export const REMOVE_OPERATION_MISMATCH_RESULTS = 'RemoveOperationMismatchResults';
export const SET_LABOR_RATE_INFO = 'SetLaborRateInfo';
export const SET_OP_CODE_SELECTED = 'SetOpCodeSelected';
export const SET_ALL_OP_CODES_SELECTED = 'SetAllOpCodesSelected';
